export default defineNuxtPlugin((nuxtApp) => {
  const clientStore = useClientStore(nuxtApp.$pinia);

  clientStore.isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  clientStore.isStandalone = !!(
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone
  );
});
